export const ShowConnectDialogEventName = 'x_show_connect_dialog';
